import { useState } from "react";
import { AdminPageLayout, AdminPageHeader } from "../../common/AdminPageLayout";
import { SUPPLIER_PAGE_META } from "../../common/supplierPageMeta";
import PackageBookings from "./package/PackageBookings";
import EventBookings from "./event/EventBookings";
import OfflineBooking from "./package/OfflineBooking";
import AttractionBookings from "./attraction/AttractionBookings";
import ActivityBookings from "./activity/ActivityBookings";
import RentalBookings from "./rental/RentalBookings";

const Booking = () => {
  const [activeTab, setActiveTab] = useState("packages");

  const renderTabContent = () => {
    switch (activeTab) {
      case "packages":
        return <PackageBookings />;
      case "events":
        return <EventBookings />;
      case "attractions":
        return <AttractionBookings />;
      case "activities":
        return <ActivityBookings />;
      case "offline":
        return <OfflineBooking />;
      case "rentals":
        return <RentalBookings />;
      default:
        return <PackageBookings />;
    }
  };

  const tabClass = (tab) =>
    `py-2 px-1 border-b-2 font-medium text-sm ${
      activeTab === tab
        ? "border-primary text-primary"
        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
    }`;

  return (
    <AdminPageLayout>
      <AdminPageHeader
        title={SUPPLIER_PAGE_META.bookings.title}
        subtitle={SUPPLIER_PAGE_META.bookings.subtitle}
      />

      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button onClick={() => setActiveTab("packages")} className={tabClass("packages")}>
              Package Bookings
            </button>
            <button onClick={() => setActiveTab("events")} className={tabClass("events")}>
              Event Bookings
            </button>
            <button onClick={() => setActiveTab("attractions")} className={tabClass("attractions")}>
              Attraction Bookings
            </button>
            <button onClick={() => setActiveTab("activities")} className={tabClass("activities")}>
              Activity Bookings
            </button>
            <button onClick={() => setActiveTab("rentals")} className={tabClass("rentals")}>
              Rental Bookings
            </button>
            <button onClick={() => setActiveTab("offline")} className={tabClass("offline")}>
              Offline Booking
            </button>
          </nav>
        </div>
      </div>

      {renderTabContent()}
    </AdminPageLayout>
  );
};

export default Booking;
